import { useStore } from 'zustand'

import { store } from '@/store'

export const useAuth = () => {
  return useStore(store)
}
